<template>
  <div class="web-wrap">
    <web-nav></web-nav>
    <div class="web-wrap__index">
      <web-header></web-header>
      <div class="web-wrap__contents"><slot /></div>
    </div>
  </div>
</template>

<script>
import WebHeader from './WebHeader.vue'
import WebNav from './WebNav.vue'
export default {
  name: 'WebTemplate',
  components: { WebHeader, WebNav },
}
</script>

<style lang="scss">
@import '@/assets/scss/init.scss';
.web-wrap {
  display: flex;
  width: 100%;
  height: 100vh;
  background: #fff;
  &__index {
    width: 100%;
    height: 100%;
  }
  &__contents {
    width: 100%;
    height: calc(100% - 60px);
    padding: 40px;
    background: #fafafa;
    overflow: auto;
  }
}
</style>
